import { AppConfigModel } from "../abstract/app-config.model";

export class Currency extends AppConfigModel {

    static override CLASS_NAME: string = 'Currency';

    readonly decimalPlaces!: number;
    readonly symbol!: string;
}
